import img1 from "../img/images/bags-p-img1-1.jpg"
import img2 from "../img/images/bags-p-img3.jpg"
import img3 from "../img/images/bags-p-img2-1.jpg"

const Data = [
    {
        id:123,
        title:"product 1",
        price:200.00,
        image:[img1],
        discountPrice:170.00,
        description:"jkjsghfndbvhjdsgtfiweh",
        category:'bags',
        brand:'',
        quantity:''
    },
    {
        id:123,
        title:"product 2",
        price:200.00,
        image:[img2],
        discountPrice:170.00,
        description:"jkjsghfndbvhjdsgtfiweh",
        category:'accessories',
        brand:'',
        quantity:''
    },
    {
        id:123,
        title:"product 3",
        price:200.00,
        image:[img3],
        discountPrice:170.00,
        description:"jkjsghfndbvhjdsgtfiweh",
        category:'men fashion',
        brand:'',
        quantity:''
    },
    {
        id:123,
        title:"product 4",
        price:200.00,
        image:[img1],
        discountPrice:170.00,
        description:"jkjsghfndbvhjdsgtfiweh",
        category:'men fashion',
        brand:'',
        quantity:''
    }
]
export default Data